import { openWindow } from '@elfsight/widget-utils';
import type { CTAButton } from '../../common';
import { CommonButton } from './common-button';

const GM_DIR_URL = 'https://www.google.com/maps/dir/Your+Location';

export const ButtonWithDirection = ({
  ctaButton,
  isFullWidth,
  contactsAddress,
  contactsName
}: {
  ctaButton: CTAButton;
  isFullWidth: boolean;
  contactsAddress: string;
  contactsName: string;
}) => {
  const clickHandler = () => {
    if (!contactsAddress) return;
    openWindow(`${GM_DIR_URL}/${contactsName}, ${contactsAddress}`, {
      target: '_blank'
    });
  };

  return (
    <CommonButton
      ctaButton={ctaButton}
      onClick={clickHandler}
      fullWidth={isFullWidth}
    />
  );
};
